<template>
  <div class="service-area pt--70 pb--50 bg_color--1">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-center section-title mb--30">
            <h2 class="heading-title">Investors</h2>
            <p class="description">
              Do you want higher returns on your investment?
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="service-main-wrapper bg-white--service">
        <v-col
          offset-sm="3"
          sm="6"
          cols="12"
          v-for="(listGroup, i) in listInfo"
          :key="i"
        >
          <div class="service service__style--2 text-left bg-gray">
            <div class="service">
              <div class="icon">
                <div v-html="iconSvg(listGroup.icon)"></div>
              </div>
              <div class="content">
                <h3 class="heading-title">{{ listGroup.title }}</h3>
                <ul class="list-style--1">
                  <li
                    class="d-flex"
                    v-for="(item, j) in listGroup.list"
                    :key="j"
                  >
                    <i v-html="iconSvg(item.icon)"></i>
                    {{ item.desc }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import feather from "feather-icons";
export default {
  data() {
    return {
      listInfo: [
        {
          icon: "users",
          title: "Investors",
          list: [
            {
              icon: "check",
              desc: `Invest in property with Zoe Estate and yield higher returns.`,
            },
            {
              icon: "check",
              desc: `Achieve high returns on your property investment without hands on hassle from anywhere in the world.`,
            },
            {
              icon: "check",
              desc: `Focus on the things you love while your investment works hard for you.`,
            },
          ],
        },
      ],
    };
  },
  methods: {
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
  },
};
</script>
